var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-3"},[(!_vm.isLoading)?_c('organism-customer-detail',{attrs:{"customer":_vm.customer}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }